//Get the closest spot to a location, based on the distance between the spots gps and the location
export function findClosestSpot(spots, lat, lng) {
  let closestSpot = null;
  let closestDistance = Infinity;

  for (const spot of spots) {
    const distance = Math.sqrt(
      Math.pow(spot.gps[0].lat - lat, 2) + Math.pow(spot.gps[0].long - lng, 2)
    );
    if (distance < closestDistance) {
      closestDistance = distance;
      closestSpot = spot;
    }
  }
  return closestSpot;
}
